import { toAnswerMap } from "services/checkIn/questionnaire-response";

export const RESET_STATUS = "checkIn/reset-status"
export const QUESTION_ANSWERED = "checkIn/question-answered"
export const LOADING_STATUS = "checkIn/loading-status"
export const STATUS_LOADED = "checkIn/status-loaded"
export const STATUS_LOADING_FAILED = "checkIn/status-load-failure"
export const SAVING_STATUS = "checkIn/saving-status"
export const STATUS_SAVED = "checkIn/status-saved"
export const SAVING_STATUS_FAILED = "checkIn/saving-status-failed"
export const SURVEY_STARTED = "checkIn/survey-started"
export const SUBSTANCE_USE_QUESTIONNAIRE_SKIPPED = "checkIn/substance-use-questionnaire-skipped"
export const SUBMITTING_SURVEY = "checkIn/submitting-survey"
export const SURVEY_SUBMITTED = "checkIn/survey-submitted"
export const SURVEY_SUBMISSION_FAILED = "checkIn/survey-submission-failed"

export function resetStatus() {
  return { type: RESET_STATUS }
}

export function questionAnswered(groupLinkId, linkId, fhirAnswer) {
  return {
    type: QUESTION_ANSWERED,
    payload: { groupLinkId, linkId, fhirAnswer }
  }
}

export function loadingStatus() {
  return { type: LOADING_STATUS }
}

export function statusLoaded(status) {
  return {
    type: STATUS_LOADED,
    payload: {
      status: {
        answers: toAnswerMap(status.answers.item),
        submitted: status.answers.status === "completed",
        hiddenCards: toAnswerMap(status.hiddenCards.item),
      },
      statusMeta: {
        answersResponseId: status.answers.id,
        answersETag: status.answers.meta.versionId,
        hiddenCardsResponseId: status.hiddenCards.id,
        hiddenCardsETag: status.hiddenCards.meta.versionId,
      }
    }
  }
}

export function statusLoadingFailed(error) {
  return { type: STATUS_LOADING_FAILED, payload: error }
}

export function savingStatus() {
  return { type: SAVING_STATUS }
}

export function statusSaved(savingOutcomeBundle, savedStatus) {
  const answersETag = savingOutcomeBundle.entry[0].response.etag
  const hiddenCardsETag = savingOutcomeBundle.entry[1].response.etag
  return {
    type: STATUS_SAVED,
    payload: { answersETag, hiddenCardsETag, savedStatus }
  }
}

export function savingStatusFailed(error) {
  return { type: SAVING_STATUS_FAILED, payload: error }
}

export function surveyStarted() {
  return { type: SURVEY_STARTED }
}

export function substanceUseQuestionnaireSkipped() {
  return {
    type: SUBSTANCE_USE_QUESTIONNAIRE_SKIPPED
  }
}

export function submittingSurvey() {
  return { type: SUBMITTING_SURVEY }
}

export function surveySubmitted() {
  return { type: SURVEY_SUBMITTED }
}

export function surveySubmissionFailed(error) {
  return { type: SURVEY_SUBMISSION_FAILED, payload: error }
}